import React from 'react'
import ReactDOM from 'react-dom'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import { getCookie, createCookie } from '../actions/user'
import { updateCustomer } from '../actions/customer'
import { fetchCountries } from '../actions/company'
import { setBreadcrumb } from '../actions/breadcrumb'
import { resetQuotes } from '../actions/quotes'

import FormInput from './FormInput'

import { RETURNS, SHIPPING } from '../assets/constant'

import { isStringEmpty, trimString } from '../assets/utils'

class ContactModal extends React.Component {

  constructor(props) {
    super()
    this.props = props
    this.onSelectCountry = this.onSelectCountry.bind(this)
    this.updateContact = this.updateContact.bind(this)
    this.resetEmptyFields = this.resetEmptyFields.bind(this)
    this.dismissModal = this.dismissModal.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.state = {
      first_name: this.props.customer.first_name,
      last_name: this.props.customer.last_name,
      email: this.props.customer.email,
      phone_number: this.props.customer.phone_number,
      line1: this.props.customer.address.line1,
      line2: this.props.customer.address.line2,
      city: this.props.customer.address.city,
      zipcode: this.props.customer.address.zipcode,
      state: this.props.customer.address.state,
      country_code: this.props.customer.address.country_code
    }
  }

  updateContact() {
    var address = {
      line1: isStringEmpty(this.state.line1) ? this.props.customer.address.line1 : trimString(this.state.line1),
      line2: trimString(this.state.line2),
      zipcode: isStringEmpty(this.state.zipcode) ? this.props.customer.address.zipcode : trimString(this.state.zipcode),
      city: isStringEmpty(this.state.city) ? this.props.customer.address.city :  trimString(this.state.city),
      state: trimString(this.state.state),
      country_code: this.state.country_code }
    var customer = {
      first_name: isStringEmpty(this.state.first_name) ? this.props.customer.first_name : trimString(this.state.first_name),
      last_name: trimString(this.state.last_name),
      email: isStringEmpty(this.state.email) ? this.props.customer.email : trimString(this.state.email),
      phone: trimString(this.state.phone_number),
      address }

    this.resetEmptyFields()
    this.props.updateCustomer(customer, shipback_id, this.props.user_token);
    this.props.resetQuotes()
    if (this.props.breadcrumb != RETURNS) {
      this.props.setBreadcrumb(SHIPPING)
    }
    this.dismissModal()
  }

  resetEmptyFields() {
    if (isStringEmpty(this.state.first_name)) {
      this.setState({ first_name: this.props.customer.first_name })
    } else {
      this.setState({ first_name: trimString(this.state.first_name) })
    }
    if (isStringEmpty(this.state.email)) {
      this.setState({ email: this.props.customer.email })
    } else {
      this.setState({ email: trimString(this.state.email) })
    }
    if (isStringEmpty(this.state.city)) {
      this.setState({ city: this.props.customer.address.city })
    } else {
      this.setState({ city: trimString(this.state.city) })
    }
    if (isStringEmpty(this.state.zipcode)) {
      this.setState({ zipcode: this.props.customer.address.zipcode })
    } else {
      this.setState({ zipcode: trimString(this.state.zipcode) })
    }
    if (isStringEmpty(this.state.line1)) {
      this.setState({ line1: this.props.customer.address.line1 })
    } else {
      this.setState({ line1: trimString(this.state.line1) })
    }
  }

  dismissModal() {
    if (!getCookie('user_token')) {
      createCookie(this.props.user_token)
    }
    $("#edit-contact").modal('hide');
    $('#edit-contact').on('hidden.bs.modal', function(e){
      $('#edit-contact-button').one('focus', function(e){$(this).blur();});
    });
  }

  onSelectCountry(event) {
    this.setState({ country_code: event.target.value })
  }

  handleChange(change) {
    this.setState(change);
  }

  render() {
    return (
      <div className="modal" id="edit-contact" tabIndex="-1" role="dialog" aria-labelledby="edit-contact" aria-hidden="true">
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-body">
              <h2>{I18n.t('shared.contact_modal.title')}</h2>
              <div className="row">
                <div className="col-10 offset-1">
                  <div className="row">
                    <div className="col-6">
                      <FormInput  required={true}
                                  label={I18n.t('activerecord.attributes.customer.first_name')}
                                  name="first_name"
                                  value={this.state.first_name ? this.state.first_name : ""}
                                  onChange={this.handleChange} />
                    </div>
                    <div className="col-6">
                       <FormInput  required={false}
                                  label={I18n.t('activerecord.attributes.customer.last_name')}
                                  name="last_name"
                                  value={this.state.last_name ? this.state.last_name : ""}
                                  onChange={this.handleChange} />
                    </div>
                    <div className="col-12">
                      <FormInput  required={true}
                                  label={I18n.t('activerecord.attributes.customer.email')}
                                  name="email"
                                  value={this.state.email ? this.state.email : ""}
                                  onChange={this.handleChange} />
                    </div>
                    <div className="col-12">
                      <FormInput  required={false}
                                  label={I18n.t('activerecord.attributes.customer.phone_number')}
                                  name="phone_number"
                                  value={this.state.phone_number ? this.state.phone_number : ""}
                                  onChange={this.handleChange} />
                    </div>
                    <div className="col-12">
                      <FormInput  required={true}
                                  label={I18n.t('activerecord.attributes.customer.address1')}
                                  name="line1"
                                  value={this.state.line1 ? this.state.line1 : ""}
                                  onChange={this.handleChange} />
                    </div>
                    <div className="col-12">
                      <FormInput  required={false}
                                  label={I18n.t('activerecord.attributes.customer.address2')}
                                  name="line2"
                                  value={this.state.line2 ? this.state.line2 : ""}
                                  onChange={this.handleChange} />
                    </div>
                    <div className="col-6">
                      <FormInput  required={true}
                                  label={I18n.t('activerecord.attributes.customer.city')}
                                  name="city"
                                  value={this.state.city ? this.state.city : ""}
                                  onChange={this.handleChange} />
                    </div>
                    <div className="col-6">
                      <FormInput  required={true}
                                  label={I18n.t('activerecord.attributes.customer.zipcode')}
                                  name="zipcode"
                                  value={this.state.zipcode ? this.state.zipcode : ""}
                                  onChange={this.handleChange} />
                    </div>
                    <div className="col-6">
                      <FormInput  required={false}
                                  label={I18n.t('activerecord.attributes.customer.state')}
                                  name="state"
                                  value={this.state.state ? this.state.state : ""}
                                  onChange={this.handleChange} />
                    </div>
                    <div className="col-6">
                      <label className="required">{I18n.t('activerecord.attributes.customer.country_code')}</label>
                      <select className="custom-select" onChange={this.onSelectCountry} value={this.state.country_code}>
                        { this.props.countries ?
                          this.props.countries.map((country) => (
                            <option key={country.country_code} value={country.country_code} >
                              {country.name}
                            </option>
                          ))
                           :
                          <option />
                        }
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 actions mb-3 mt-3">
                <a className="submit" onClick={this.updateContact}>
                  {I18n.t('shared.contact_modal.save')}
                </a>
              </div>
              <div className="col-12 actions">
                <a className="dismiss" onClick={this.dismissModal}>{I18n.t('shared.contact_modal.cancel')}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  shipback: state.shipback,
  countries: state.company.countries,
  user_token: state.user,
  breadcrumb: state.breadcrumb,
  customer: state.customer
})

const mapDispatchToProps = dispatch => bindActionCreators({ updateCustomer, fetchCountries, setBreadcrumb, resetQuotes }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ContactModal)



// WEBPACK FOOTER //
// ./app/javascript/components/components/ContactModal.jsx